import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-208">
      <div className="max-w-2xl mx-auto text-center" data-id="element-209">
        {/* Shield icon */}
        <div className="text-8xl mb-6" data-id="element-210">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#00B4D8] mb-4" data-id="element-211">
          GARANTÍA PROFEPACK™ — 7 DÍAS
        </h2>

        <div className="bg-[#000d1a] border-2 border-[#00B4D8] rounded-2xl p-8 mb-6" data-id="element-212">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-213">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en el aula si
            querés.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-214">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#00B4D8] text-3xl font-black mb-4" data-id="element-215">
            Te devolvemos el 100%.
          </p>
          <p className="text-white text-xl font-bold" data-id="element-216">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-217">
          ✅ +500 docentes lo compraron. Menos de 5 lo devolvieron. Eso no es
          marketing. Es confianza real.
        </p>
      </div>
    </section>;
}